<template>
  <div class="font_16" style="height:100%;width:100%;overflow:hidden auto;">
    <el-container v-loading="loading" style="background:white;">
      <el-container>
        <el-main style="padding: 5% 20px 0 20px;">
          <el-row class="font_16">
            ユーザーのパスワードを変更できます。
          </el-row>
          <el-row>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" label-position="top"
              style="max-width:350px;min-width:200px;">
              <el-form-item label="農家ID" prop="farmer_id" class="font_18">
                <el-input class="login font_18" v-model="form.farmer_id" autocomplete="farmer_id" placeholder="farmer_id"
                  :maxlength="64" :disabled="lockFarmerId" ref="firstInput" style="max-width:335px;min-width:185px;" />
              </el-form-item>
              <el-form-item label="メールアドレス" prop="mailaddress">
                <el-input class="font_18" type="email" v-model="form.mailaddress" autocomplete="mailaddress"
                  placeholder="mail@address" :maxlength="maxLength" ref="secondInput"
                  style="max-width:335px;min-width:185px;" />
              </el-form-item>
              <el-form-item label="旧パスワード" prop="password">
                <el-input v-if="!showPassword" class="font_18" type="password" v-model="form.password"
                  autocomplete="password" placeholder="old password" :suffix-icon="IconEyeSlash" :minlength="8"
                  :maxlength="maxLength" style="max-width:335px;min-width:185px;" />
                <el-input v-if="showPassword" class="font_18" v-model="form.password" autocomplete="password"
                  placeholder="old password" :suffix-icon="IconEye" :minlength="8" :maxlength="maxLength"
                  style="max-width:335px;min-width:185px;" />
                <div style="width:0px;height:50px;position:relative;">
                  <el-button class="btn-height" type="primary" @click="showPassword = !showPassword"
                    style="position:absolute;left:-33px;top:0px;opacity:0;" />
                </div>
              </el-form-item>
              <el-form-item label="新パスワード" prop="newPassword">
                <el-input v-if="!showNewPassword" class="font_18" type="password" v-model="form.newPassword"
                  autocomplete="newPassword" placeholder="new password" :suffix-icon="IconEyeSlash" :minlength="8"
                  :maxlength="maxLength" style="max-width:335px;min-width:185px;" />
                <el-input v-if="showNewPassword" class="font_18" v-model="form.newPassword" autocomplete="newPassword"
                  placeholder="new password" :suffix-icon="IconEye" :minlength="8" :maxlength="maxLength"
                  style="max-width:335px;min-width:185px;" />
                <div style="width:0px;height:50px;position:relative;">
                  <el-button class="btn-height" type="primary" @click="showNewPassword = !showNewPassword"
                    style="position:absolute;left:-33px;top:0px;opacity: 0;" />
                </div>
              </el-form-item>
              <el-form-item>
                <el-row class="font_12 text-center">
                  <p>[パスワードポリシー]<br>
                    ・パスワードは8文字以上入力してください。<br>
                    ・数字、英大文字、英小文字を1文字以上含めてください。<br>
                    ・以下の特殊文字のいずれか1文字以上を含めてください。<br>
                    特殊文字： ^$*.[]{}()?-&quot;!@#%&amp;/\,&gt;&lt;&#39;:;|_~`+=</p>
                </el-row>
                <el-row style="width:100%;">
                  <p v-if="message" style="color: #F56C6C;">{{ message }}</p>
                </el-row>
                <el-row style="justify-content:center;width:100%;">
                  <el-button class="button-style" color="#ffdf5e" round @click="click_signin">変更</el-button>
                </el-row>
              </el-form-item>
            </el-form>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { ElMessageBox } from 'element-plus'
import { CognitoUserAccessor } from "./js/cognito-login";
import { signout } from "./js/cognito";
import ConstParam from './js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules';

export default {
  components: {
  },
  mounted() {
    let paramFarmerId = this.$route.query.farmer_id;
    if (typeof paramFarmerId === 'undefined') {
      paramFarmerId = "";
    }
    if (paramFarmerId === "") {
      this.$refs.firstInput.focus()
    } else {
      this.form.farmer_id = paramFarmerId;
      this.lockFarmerId = true;
      this.$refs.secondInput.focus()
    }
  },
  data() {
    return {
      lockFarmerId: false,
      IconEye: shallowRef(icons.IconEye),
      IconEyeSlash: shallowRef(icons.IconEyeSlash),
      showPassword: false,
      showNewPassword: false,
      showPasswordDialog: false,
      maxLength: ConstParam.maxLength,
      loading: false,
      // 定数値
      version_text: ConstParam.version_text,
      copyright_text: ConstParam.copyright_text,
      // その他
      message: "",
      id_token: "",
      form: {
        farmer_id: "",
        mailaddress: "",
        password: "",
        newPassword: "",
      },
      // Cognitoオブジェクト.
      cognitoUser: {},

      // ルール
      rules: {
        farmer_id: [
          { required: true, message: 'この項目は入力が必須です。' },
        ],
        mailaddress: [
          { required: true, message: 'この項目は入力が必須です。' },
        ],
        password: [
          { required: true, message: 'この項目は入力が必須です。' },
        ],
        newPassword: [
          { required: true, message: 'この項目は入力が必須です。' },
          { min: 8, message: '8文字以上で入力してください。' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S+$/, message: '大文字・小文字・数字、特殊文字をそれぞれ１文字以上含む必要があります。' },
        ],
      }
    };
  },
  methods: {
    passwordMessage(message) {
      this.$alert(message, "", {
        confirmButtonText: 'もう一度実行'
      }).catch(() => {
        return
      });
    },
    viewMessage(message) {
      ElMessageBox(message, '', {})
    },
    async clickChangePassword() {
      CognitoUserAccessor.changePassword(this.form.password, this.form.newPassword)
        .then(() => {
          this.loading = false;
          this.message = ''
          this.$refs.formRef.resetFields()
          this.signOut();
          this.viewMessage('パスワードを変更しました。')
          this.$router.push('/phonereturnapplication')
        })
        .catch(error => {
          this.loading = false;
          this.message = ''
          this.$refs.formRef.resetFields()
          this.signOut();
          this.viewMessage('パスワード変更に失敗しました。(' + error.message + ')')
        })
    },
    async signOut() {
      await signout();
    },
    async signIn() {
      // ログイン情報.
      const username = this.form.farmer_id + "@" + this.form.mailaddress;
      const password = this.form.password;
      // サインイン.
      const cognitoUser = new CognitoUserAccessor();
      cognitoUser.init(username, password);
      try {
        const result = await cognitoUser.signin();
        // ローディング
        this.loading = false;
        // 結果判定.
        if ("newPasswordRequired" in result) {
          this.viewMessage('パスワード変更に失敗しました。')
        } else {
          // 成功.
          this.id_token = result.idToken.jwtToken;
          // this.$router.replace('/')
          this.clickChangePassword();
        }
      } catch (e) {
        // ローディング
        this.loading = false;
        // 失敗.
        this.viewMessage('パスワード変更に失敗しました。')
      }
    },
    async click_signin() {
      const re = new RegExp(ConstParam.password_reg)
      if (!re.test(this.form.newPassword)) {
        this.passwordMessage(ConstParam.password_error)
        return
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.message = '赤枠表示部分の入力内容を修正してください。'
          return
        }
        try {
          // ローディング
          this.loading = true;
          this.signIn();
        } catch (e) {
          // ローディング
          this.loading = false;
          // 失敗.
          this.viewMessage('パスワード変更に失敗しました。')
        }
      })
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
  height: 50px;
}

.btn-height {
  height: 50px;
}

#login_button {
  color: #383838;
  background: #ffdf5e;
}
</style>